<template>
  <div class="ml-5 mr-5">
    <div class="text-center">
      <loading :active.sync="isLoaderVisible" :can-cancel="false" loader="dots" color="#007bff" :height="45" :width="75"
        :is-full-page="true"></loading>
    </div>

    <div class="text-left">
      <v-container fluid>
        <v-row class="no-gutters">
          <search-field label="Search By Email" @search="handleEmailSearch" @reset="resetEmailSearch" />
          <v-col class="d-flex align-center justify-end" style="flex-wrap: wrap;">
            <v-btn color="primary" class="mr-2" small v-show="checkIfOperationExistForModule('add')"
              @click="showMemberImportDialog = true">
              Import
            </v-btn>
            <v-btn color="primary" class="mr-4" small v-show="checkIfOperationExistForModule('view')"
              @click="handleMembersExport">
              Export
            </v-btn>

            <v-btn color="primary" class="mr-4" small v-show="checkIfOperationExistForModule('add')"
              @click="showMemberForm = true">
              Add Members
            </v-btn>
            <v-btn class="mr-2" color="primary" small :disabled="selectedItems.length === 0"
              v-show="checkIfOperationExistForModule('edit')" @click="handleToggleActivateRecords">
              Activate/Block
            </v-btn>

            <v-btn color="primary" class="mr-0" small v-show="checkIfOperationExistForModule('delete')"
              :disabled="selectedItems.length === 0" @click="handleDeleteRecords">
              Delete
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="tableWrapper">
              <v-data-table :loading="isLoading" :headers="headers" :items="items" :page.sync="page"
                :options.sync="options" :server-items-length="totRecords" :sortBy.sync="sortBy"
                :sort-desc.sync="sortDesc" @page-count="pageCount = $event" v-model="selectedItems" hide-default-footer
                show-select item-key="userID" class="elevation-1">
                <template v-slot:item.actions="{ item }">
                  <v-row class="no-gutters">
                    <v-col cols="auto">
                      <v-icon class="mr-1" @click="handleEditRecord(item)" title="Edit"
                        v-show="checkIfOperationExistForModule('edit')">
                        mdi-pencil
                      </v-icon>
                    </v-col>

                    <v-col cols="auto">
                      <v-icon @click="handleLoginAsUser(item)" title="Login as this user"
                        v-show="checkIfOperationExistForModule('view')">
                        mdi-login
                      </v-icon>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.is_mfa="{ item }">
                  <v-switch v-model="item.is_mfa" inset dense @change="handleToggleMfa(item)"></v-switch>
                </template>

               <template v-slot:item.enableSSO="{ item }">
  <v-switch v-model="item.enableSSO" inset dense @change="(val) => handleToggleSSO(item, val)" />
</template>


              </v-data-table>

              <div class="text-center pt-4 pb-4">
                <Pagination :isloading="isLoading" :startRecord="startRecord" :currentPage="currentPage"
                  :lastPage="lastPage" :lastRecord="lastRecord" :totRecords="totRecords"
                  :isCurrentPageClass="isCurrentPageClass" :perpage="perpage" :getLastPageClass="getLastPageClass"
                  :totPage="totPage" :getPages="getPages" @handlePerPage="handlePerPage" @paginate="paginate"
                  @last="last" @getDataByPage="getDataByPage" :showPerPage="true" />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <member-import-dialog :isOpen="showMemberImportDialog" v-if="showMemberImportDialog"
      @close="showMemberImportDialog = false" @loading="(value) => isImportMembersLoading = value"
      @success="handleMembersImportSuccess" />
    <member-form :isOpen="showMemberForm" :userId="editUserId" v-if="showMemberForm"
      @close="showMemberForm = false, editUserId = undefined, isMemberFormLoading = false"
      @loading="(value) => isMemberFormLoading = value" @success="handleMemberSaveSuccess" />
  </div>
</template>
<script>

import Loading from "vue-loading-overlay";
import Pagination from "./component/Pagination.vue";
import SearchField from './component/SearchField.vue';
import MemberImportDialog from "./components/manage-members/MemberImportDialog.vue";
import MemberForm from "./components/manage-members/MemberForm.vue";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: { Loading, Pagination, SearchField, MemberImportDialog, MemberForm },
  data() {
    return {
      items: [],
      selectedItems: [],
      options: {},
      isLoading: false,
      page: 1,
      pageCount: 0,
      perpage: 10,
      totRecords: 0,
      emailSearchQuery: '',
      sortDesc: [false],
      sortBy: ["emailAddress"],

      isMemberFormLoading: false,
      showMemberForm: false,
      showMemberImportDialog: false,
      isToggleActivate: false,
      isToggleMfa: false,
      isDeletingRecords: false,
      isImportMembersLoading: false,
      isImportingMembers: false,
      isExportingMembers: false,
      editUserId: null,

      headers: [
        {
          text: "Member Email",
          value: "emailAddress",
          sortable: true,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Company Name",
          value: "companyName",
          sortable: true,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Active",
          value: "active",
          sortable: true,
          width: "100",
          class: "v-data-table-header",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "100",
          class: "v-data-table-header",
        },
        {
          text: "MFA",
          value: "is_mfa",
          sortable: false,
          width: "50",
          class: "v-data-table-header",
        },
        {
          text: "SSO",
          value: "enableSSO",
          sortable: false,
          width: "50",
          class: "v-data-table-header",
        },

      ],
    };
  },
  computed: {
    isLoaderVisible() {
      return this.isLoading
        || this.isToggleActivate
        || this.isDeletingRecords
        || this.isImportingMembers
        || this.isExportingMembers
        || this.isMemberFormLoading
        || this.isImportMembersLoading
        || this.isToggleMfa
    },
    usersPayload() {
      return {
        page_number: this.page,
        page_size: this.perpage,
        emailAddress: this.emailSearchQuery,
        sort_by: this.sortBy?.[0] || 'emailAddress',
        sort_order: this.sortDesc?.[0] ? "desc" : "asc"
      }
    },
    //pagination computed methods
    startRecord: function () {
      return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1);
    },
    lastRecord: function () {
      return this.perpage * this.currentPage;
    },
    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },
    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },
    totPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },
    currentPage: function () {
      return this.page;
    },
    lastPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    endIndex: function () {
      return this.perpage * this.page;
    },
    startIndex: function () {
      if (this.page == 1) {
        return this.perpage * 0;
      } else {
        return this.endIndex - this.perpage;
      }
    },
  },
  watch: {
    emailSearchQuery() {
      this.fetchUsers();
    },
    options: {
      handler() {
        requestAnimationFrame(() => {
          this.fetchUsers();
        })
      },
      deep: true,
    }
  },
  methods: {
    getDataByPage(value) {
      this.page = value;
    },
    handlePerPage(value) {
      if (this.perpage === value) {
        return;
      }
      this.selectedItems = []
      this.perpage = value;
      this.page = 1;
      this.fetchUsers()
    },
    paginate(n) {
      if (n == 0) {
        this.page = 1
      } else {
        const nextPage = this.page + n;
        this.page = Math.min(Math.max(1, nextPage), this.pageCount)
      }
    },
    last() {
      this.page = this.lastPage;
    },

    handleEmailSearch(query) {
      this.emailSearchQuery = query
      this.page = 1;
    },
    resetEmailSearch() {
      this.emailSearchQuery = ''
      this.page = 1;
    },

    handleMemberSaveSuccess(addMore) {
      this.showMemberForm = false
      this.isMemberFormLoading = false
      this.editUserId = undefined
      this.fetchUsers();
      this.$swal.fire({
        icon: "success",
        title: "Success",
        text: "Users saved successfully",
      });
      if (addMore) {
        requestAnimationFrame(() => {
          this.showMemberForm = true
        })
      }
    },

    handleMembersImportSuccess(accepted) {
      this.showMemberImportDialog = false
      this.isImportMembersLoading = false
      this.fetchUsers();
      this.$swal.fire({
        icon: "success",
        title: "Success",
        text: accepted
          ? "Accepted records imported successfully"
          : "Declined records deleted successfully",
      });
    },

    async fetchUsers() {
      this.isLoading = true;

      try {
        const usersListingUrl = this.$url("LISTING_USERS");

        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).post(usersListingUrl, this.usersPayload);

        const payload = response.data?.payload || {};
        const users = payload.users || [];

        console.log("USER FROM API =>", users[0]);

        this.items = users.map(item => ({
          ...item,
          active: item.active === "y" ? "Yes" : "No",
          is_mfa: item.is_mfa === 1,
          enableSSO: item.is_sso === 1,

          company_domain: item.companyDomain,

        }));

        this.totRecords = payload.count || 0;
        this.pageCount = payload.total_pages || 0;

      } catch (error) {
        this.items = [];
        this.totRecords = 0;
      } finally {
        this.isLoading = false;
      }
    },


    async handleEditRecord(item) {
      this.editUserId = item?.userID;
      this.showMemberForm = true;
    },

    async handleLoginAsUser(item) {
      let token = this.$utils.getAccessToken();
      const memberLoginUrlV1 = this.$url('MEMBER_LOGIN_V1')
      if (!memberLoginUrlV1) {
        return
      }
      window.open(`${memberLoginUrlV1}?token=${token}&id=${btoa(item?.emailAddress)}&is_admin=true`, "_blank");
    },

    async handleMembersExport() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "Export all records?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Export",
          cancelButtonText: "No, cancel!",
          closeOnConfirm: false,
          closeOnCancel: false,
        })
        .then(async (result) => {
          if (!result.isConfirmed) {
            return;
          }
          try {
            this.isExportingMembers = true;
            let membersExportUrl = this.$url('EXPORT_CLIENT_REPORT')
            const response = await this.$fetch({ requiresAuth: true, operation: 'add', vueScope: this })
              .post(membersExportUrl, {
                "userID": this.selectedItems.map(item => item.userID),
                "page": this.page || 1,
                "perpage": this.perpage || 10,
                "options": {
                  // "filter": "active",
                  "sort_by": this.usersPayload.sort_by,
                  "order": this.usersPayload.sort_order

                }
              })
            if (response.data) {
              this.downloadCSV(response.data)
            } else {
              this.downloadCSV(response.data)
            }

          } catch (error) {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong!",
            });
          } finally {
            this.isExportingMembers = false;
          }
        });
    },

    async handleToggleMfa(item) {
      this.isToggleMfa = true;
      let data = {
        email: item.emailAddress,
        is_mfa: item.is_mfa ? true : false
      };
      try {
        let updateMfaUrl = this.$url("MEMBER_UPDATE_MFA");
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "edit",
          vueScope: this,
        }).post(updateMfaUrl, data);
        if (response.data?.code == 200) {
          this.$swal.fire({
            icon: "success",
            title: "",
            text: item.is_mfa ? "MFA Enabled" : "MFA Disabled",
          });
          this.fetchUsers();
          this.selectedItems = []
        } else {
          throw new Error('Something went wrong')
        }
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        });
      } finally {
        this.isToggleMfa = false;
      }
    },

    async handleToggleSSO(item, newValue) {
      this.isToggleActivate = true;
      try {
        const updateUrl = this.$url("USER_UPDATE_SSO");
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "edit",
          vueScope: this,
        }).put(updateUrl, {
          emailAddress: item.emailAddress,
          enableSSO: newValue,
        });
        const resData = response?.data;


        if (resData?.message === "Please Enable SSO for the Domain") {
          this.$swal.fire({
            icon: "warning",
            text: resData.message,
          });
          item.enableSSO = !newValue;
          return;
        }

        if (!resData || resData.code !== 200) {
          item.enableSSO = !newValue;
          this.$swal.fire({
            icon: "warning",
            text: resData?.message || "Unable to update SSO",
          });
          return;
        }

        item.enableSSO = newValue;
        this.$swal.fire({
          icon: "success",
          text: newValue ? "SSO Enabled" : "SSO Disabled",
        });

      } catch (error) {
        item.enableSSO = !newValue;
        this.$swal.fire({
          icon: "error",
          text: error?.response?.data?.message || "Unable to update SSO status",
        });
      } finally {
        this.isToggleActivate = false;
      }
    },

    async handleToggleActivateRecords() {
      if (!this.selectedItems?.length) {
        return;
      }
      this.isToggleActivate = true;
      let data = {
        userID: this.selectedItems.map((item) => item.userID),
        email: this.selectedItems.map((item) => item.emailAddress)
      };
      try {
        let updateUsersUrl = this.$url("CLIENT_PROFILE");
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "patch",
          vueScope: this,
        }).patch(updateUsersUrl, data);
        if (response.data?.status == 'success') {
          this.$swal.fire({
            icon: "success",
            title: "Selected record(s) has been updated",
            text: response.data?.message,
          });
          this.fetchUsers();
          this.selectedItems = []
        } else {
          throw new Error('Something went wrong')
        }
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong!",
        });
      } finally {
        this.isToggleActivate = false;
      }
    },

    async handleDeleteRecords() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "This will delete selected records",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          closeOnConfirm: false,
          closeOnCancel: false,
        })
        .then(async (result) => {
          if (!result.isConfirmed || !this.selectedItems?.length) {
            return;
          }

          this.isDeletingRecords = true;
          let data = {
            userID: this.selectedItems.map((item) => item.userID),
            email: this.selectedItems.map((item) => item.emailAddress),
          };
          try {
            let deleteUsersUrl = this.$url("CLIENT_PROFILE");
            const response = await this.$fetch({
              requiresAuth: true,
              operation: "delete",
              vueScope: this,
            }).delete(deleteUsersUrl, { data });
            if (response.data?.status == 'success') {
              this.$swal.fire({
                icon: "success",
                title: "Selected record(s) deleted successfully.",
              }).then(() => {
                location.reload();
              });
            } else {
              throw new Error('Something went wrong')
            }
          } catch (error) {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Something went wrong!",
            });
          } finally {
            this.isDeletingRecords = false;
          }
        });
    },

    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(this, type);
    },

    downloadCSV(data) {
      let blob = new Blob([data], { type: "text/csv" });
      var a = document.createElement('a');
      var url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `members.csv`;
      document.body.append(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    }
  },
};
</script>
